import { Projeto } from "./Projeto";
import { Usuario } from "./Usuario";

export class Comentario {
    id?: number;
    projeto?: Projeto;
    usuario?: Usuario;
    data?: Date;
    detalhe?: string;
}